import { render } from "./FeatureComp.vue?vue&type=template&id=12162a84&scoped=true&ts=true"
import script from "./FeatureComp.vue?vue&type=script&lang=ts"
export * from "./FeatureComp.vue?vue&type=script&lang=ts"

import "./FeatureComp.vue?vue&type=style&index=0&id=12162a84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12162a84"]])

export default __exports__